<script setup>
import { RemoveFilled } from "@element-plus/icons-vue";

const props = defineProps([ 'filterData','removeFilter','id', 'columns']);

const operatorOptions = [
        {
            value: '=', label: 'Equal', operator: '='
        },
        {
            value: '!=', label: 'Not Equal', operator: '!='
        },
        {
            value: 'LIKE', label: 'Contain', operator: 'LIKE'
        },
        {
            value: 'NOT LIKE', label: 'Not Contain', operator: 'NOT LIKE'
        }
];

</script>

<template>
    <div class="fv-form-row fv-gap-1">
        
        <el-select v-model="props.filterData.filter" placeholder="Select">
            <el-option
            v-for="item in columns"
            :key="item.colKey"
            :label="item.alias"
            :value="item.colKey"
            />
        </el-select>
        <el-select v-model="props.filterData.operator" placeholder="Select">
            <el-option
            v-for="item in operatorOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            />
        </el-select>
        <el-input class="wml-filter-value" placeholder="Enter Value" v-model="props.filterData.value" />
        <el-icon v-if="id != 0" class="el-icon--left fv-remove-condition" @click="(e) => removeFilter(e,props.id)" :id="props.id"><RemoveFilled /></el-icon>
    </div>
</template>